<template lang="html">
  <div>
    <h4>{{ campaign.name }} {{$t('article.on')}} {{ tag.name }} {{tag.status}}</h4>
      <b-aspect :aspect="getAspect(campaign.media)" style="width: 50%" class="mx-auto">
        <Campaignv style="height: 100%" :media="campaign.media.data" />
      </b-aspect>
      <b-table-simple responsive>
        <b-thead>
          <b-tr>
            <b-th>{{$t('dateTime.runDates')}}</b-th>
            <b-th>{{$t('dateTime.dailyTimes')}}</b-th>
            <b-th>{{$t('dashboard.approval.status')}}</b-th>
            <b-th></b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-if="firstBooking">
            <b-td v-if="firstBooking.startDate === firstBooking.endDate">{{ firstBooking.startDate }}</b-td>
            <b-td v-else-if="firstBooking.endDate >= '2037-01-01'">{{ firstBooking.startDate }}, no end date</b-td>
            <b-td v-else>{{ firstBooking.startDate }} to {{ firstBooking.endDate }}</b-td>
            <b-td v-if="firstBooking.startTime === '00:00:00' && firstBooking.endTime === '23:59:59'">All Day</b-td>
            <b-td v-else>{{ firstBooking.startTime }} to {{ firstBooking.endTime }}</b-td>
            <b-td v-if="firstBooking.approval === 'pending'"><b-badge>Pending Approval</b-badge></b-td>
            <b-td v-else-if="firstBooking.approval === 'approved' && firstBooking.endDate >= date && firstBooking.startDate <= date && firstBooking.endTime >= time && firstBooking.startTime <= time"><b-badge variant="success">Running</b-badge></b-td>
            <b-td v-else-if="firstBooking.approval === 'approved'"><b-badge variant="warning">Booked</b-badge></b-td>
            <b-td v-else-if="firstBooking.approval === 'denied'"><b-badge variant="danger">Pending Denied</b-badge></b-td>
            <b-td>
              <b-button size="sm" variant="danger" @click="removeCampaign()">{{$t('buttons.remove')}}</b-button>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>

    <b-button variant="primary" @click="$emit('add')">{{$t('buttons.add')}}</b-button>
  </div>
</template>

<script>
import { clock } from '@/lib/clock'
import Campaignv from '@/components/Player/PropPlayer.vue'
import aspectRatio from '@/mixins/aspectRatio'

export default {
  mixins: [aspectRatio],
  components: {
    Campaignv
  },
  props: {
    campaign: {
      type: Object,
      required: true
    },
    tag: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      ...clock(),
    }
  },
  computed: {
    firstBooking () {
      return this.filteredCampaigns[0] || null
    },
    filteredCampaigns () {
      let matched = []
      for (let display of this.tag.displays) {
        let bookings = display.bookings.data
          .filter(b => b.campaignId === this.campaign.campaignId)
          .map(b => ({ ...b, _display: display }))
        matched = matched.concat(bookings)
      }
      return matched
    },
  },
  methods: {
    removeCampaign () {
      let requests = this.filteredCampaigns.map(b =>
        this.$axios.delete('v1/displays/' + b._display.displayId + '/campaigns/' + b.id).then(() => {
          b._display.bookings.data = b._display.bookings.data.filter(x => x.id !== b.id)
        })
      )
      Promise.all(requests).then(
        () => {
          this.$notifications.add({
            title: 'Deleted',
            type: 'success',
            body: this.$t('notifications.campaignRemove'),
            timeout: true
          })
          this.$emit('deleted')
        },
        () => {
          this.$notifications.add({
            title: 'Alert',
            type: 'warning',
            body: this.$t('notifications.campaignRemoveError'),
            timeout: true
          })
        }
      )
    }
  }
}
</script>

<style lang="css">
</style>
